/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmEmailAddressCommand
 */
export interface ConfirmEmailAddressCommand {
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailAddressCommand
     */
    token: string;
}

export function ConfirmEmailAddressCommandFromJSON(json: any): ConfirmEmailAddressCommand {
    return ConfirmEmailAddressCommandFromJSONTyped(json, false);
}

export function ConfirmEmailAddressCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmailAddressCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ConfirmEmailAddressCommandToJSON(value?: ConfirmEmailAddressCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

